import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import CategoryHeading from '../../../CategoryHeading';
import breakpoints from '../../../Theme/breakpoints';

const MoreNewsWrapper = styled.section`
  @media (min-width: ${breakpoints.lg}px) {
    padding: 24px 0 0;
    border-top: 1px solid ${({ theme }) => theme.colors?.greyDark};
  }
`;

const MoreNewsRow = styled.div`
  display: block;

  @media (min-width: ${breakpoints.sm}px) {
    display: flex;
    flex-wrap: wrap;
  }

  @media (min-width: ${breakpoints.lg}px) {
    padding: 24px 0;
    border-top: 1px solid ${({ theme }) => theme.colors?.greyLight};
    flex-wrap: nowrap;
    justify-content: space-between;
    :first-of-type {
      padding: 0 0 24px;
      border-top: none;
    }
  }
`;

const MoreNewsItem = styled.div`
  @media (min-width: ${breakpoints.sm}px) {
    flex-basis: calc(50% - (16px));
    padding: 0 16px 0 0;

    &:nth-of-type(3) {
      padding: 0 16px 0 0;
    }

    &:nth-of-type(2) {
      padding: 0 0 0 16px;
    }

    &:nth-of-type(4) {
      padding: 0 0 0 16px;
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    &&& {
      flex-basis: calc(25%);
      margin: 0 24px 0 0;
      border-left: none;
      padding: ${(properties) => properties.padding};
      border-right: ${(properties) => properties.borderRight};

      &:nth-of-type(4) {
        padding: 0;
        margin: 0;
      }
    }
  }
`;

const StyledCategoryHeading = styled(CategoryHeading)`
  && {
    margin-bottom: 24px;

    @media (min-width: ${breakpoints.sm}px) {
      flex-basis: calc(100%);
    }
  }
`;

const MoreNews = ({
  categoryHeading,
  rows,
}) => (
  <MoreNewsWrapper>
    <StyledCategoryHeading>
      {categoryHeading}
    </StyledCategoryHeading>
    { rows.map(
      (block) => (
        <MoreNewsRow key={block.props.offset}>
          {block}
        </MoreNewsRow>
      ),
    ) }
  </MoreNewsWrapper>
);

MoreNews.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.node,
  ).isRequired,
  categoryHeading: PropTypes.string,
};

MoreNews.defaultProps = {
  categoryHeading: undefined,
};

export { MoreNews, MoreNewsItem, StyledCategoryHeading };
